// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 937 ? "eabe11fc" : chunkId) + "." + {"98":"c9648df1a44ad268","167":"72b23eff0e1113b2","742":"d2406cfd72c17506","764":"4e9f62f4d7b597ef","937":"03644a77edfd3f7f"}[chunkId] + ".js";
};